import React from "react";

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

const MyModal = (props: Props) => {
  const { children, isOpen, onClose } = props;

  if (!isOpen) return null;

  return (
    <div className="myModal">
      <div className="myModalBackdrop" onClick={onClose}></div>
      <div className="myModal_box">
        <div className="myModalClose" onClick={onClose}>
          <span>X</span>
        </div>

        {children}
      </div>
    </div>
  );
};

export default MyModal;
